import React, { Component, PropTypes } from 'react';

export default class HeadingH2 extends Component {
	static propTypes = {
		qaSelector: PropTypes.string,
		headingDecoratorClass: PropTypes.string,
		children: React.PropTypes.oneOfType([
			PropTypes.arrayOf(PropTypes.node),
			PropTypes.node
		])
	};
	static defaultProps = {
		headingDecoratorClass: ''
	};
	render() {
		const {
			children,
			qaSelector,
			headingDecoratorClass
		} = this.props;

		return (
			<h2 data-qa={qaSelector} className={`dna-h2 ${headingDecoratorClass}`}>
				{ children }
			</h2>
        );
	}
}



// WEBPACK FOOTER //
// ../~/dna-typography/components/typography/HeadingH2.jsx